import addMenues_store from './components/addMenus.js'
import addRoutes_store from './components/addRoutes.js'

export default{
    menu:addMenues_store,
    route:addRoutes_store
}


// WEBPACK FOOTER //
// ./src/store/modules.js